import { useMemo } from 'react'
import { PassengerGroups } from '../types'
import { countPassengers } from '../../utils'
import { getIsInfantPricingEligible } from '../../common/multiPaxPricingEligibility'
import { roundupToTwoDecimalPlaces } from '../../utils/priceCalculation'

export function countFlightPassengers({ passengers, pclnBootstrapData }) {
  const passengerTypes = [PassengerGroups.ADULT, PassengerGroups.CHILD]

  if (getIsInfantPricingEligible({ pclnBootstrapData })) {
    passengerTypes.push(PassengerGroups.LAP_INFANT)
  }
  const includedPassengerGroups = new Set(passengerTypes)
  return countPassengers(passengers, includedPassengerGroups)
}

export function getTotalPrice(totalPricingObject, bagSelectionTotal, bagSelectionFeeTotal, seatsTotal = 0) {
  if (totalPricingObject?.type !== 'TOTAL_PRICE') {
    return null
  }
  const { amount } = totalPricingObject
  return roundupToTwoDecimalPlaces(seatsTotal + amount + bagSelectionTotal + bagSelectionFeeTotal).toString()
}

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

export function useCheckoutExpandableDetails(
  seatUnitPrice,
  passengerCount,
  bagSelectionTotal,
  bagSelectionFeeTotal,
  seatsTotal
) {
  return useMemo(() => {
    const details = [
      {
        name: 'Cost per person',
        value: `$${seatUnitPrice}`,
        testId: 'cta-cost-per-person',
      },
      {
        name: 'Number of travelers',
        value: `${passengerCount}`,
        testId: 'cta-num-of-travelers',
      },
    ]
    if (bagSelectionTotal > 0) {
      details.push({
        name: 'Baggage Fees',
        value: `$${parseFloat(bagSelectionTotal).toFixed(2)}`,
        testId: 'cta-baggage-fees',
      })
    }

    if (bagSelectionFeeTotal > 0) {
      details.push({
        name: 'Convenience Fees',
        value: `$${parseFloat(bagSelectionFeeTotal).toFixed(2)}`,
        testId: 'cta-convenience-fees',
      })
    }
    if (seatsTotal > 0) {
      details.push({
        name: 'Seats Fees',
        value: formatter.format(seatsTotal),
        testId: 'cta-seats-fees',
      })
    }
    return details
  }, [seatUnitPrice, passengerCount, bagSelectionTotal, bagSelectionFeeTotal, seatsTotal])
}
